import type { ReactNode } from 'react'
import { styled } from 'styled-components'
import { mediaDesktop, mediaTabletAndMobile } from './styles/breakPoints'

const Div = styled.div<{ $center?: boolean }>`
  width: 100%;
  max-height: 100%;
  overflow: auto;
  flex-grow: 1;
  text-align: ${p => (p.$center ? 'center' : 'left')};
  ${mediaTabletAndMobile} {
    -webkit-overflow-scrolling: touch;
    padding: 0 16px;
  }

  ${mediaDesktop} {
    padding: 0 32px;
  }
`
type SectionProps = {
  className?: string
  center?: boolean
  children: ReactNode
}
const Section = ({ className, children, center }: SectionProps) => (
  <Div $center={center} className={className}>
    {children}
  </Div>
)

export default Section
